module.exports = __webpack_public_path__ + "static/img/sixFour.99f73c95.png";